import {
  buildPageMeta,
  buildRobotsContent,
  buildStructuredDataScript,
} from '@/utils/seo';

type DirectorySeoHeadProps = {
  pageMeta: ReturnType<typeof buildPageMeta>;
  scripts: Array<ReturnType<typeof buildStructuredDataScript>>;
  isNoindex?: boolean;
};

const DirectorySeoHead = ({
  pageMeta,
  scripts,
  isNoindex = false,
}: DirectorySeoHeadProps) => (
  <>
    {pageMeta.meta.map((meta) => {
      if ('title' in meta) {
        return <title key="title">{meta.title}</title>;
      }
      if ('name' in meta) {
        return <meta key={meta.name} name={meta.name} content={meta.content} />;
      }
      return (
        <meta
          key={meta.property}
          property={meta.property}
          content={meta.content}
        />
      );
    })}
    <meta name="robots" content={buildRobotsContent({ isNoindex })} />
    {pageMeta.links.map((link) => (
      <link key={`${link.rel}:${link.href}`} rel={link.rel} href={link.href} />
    ))}
    {scripts.map((script) => (
      <script key={script.children} type={script.type}>
        {script.children}
      </script>
    ))}
  </>
);

export default DirectorySeoHead;
